/* eslint-disable no-restricted-syntax */
/* eslint-disable no-await-in-loop */
/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
// eslint-disable-line no-nested-ternary

import React, { useState, useEffect } from "react";
import {
    Grid, Button, IconButton, TextField, Select, MenuItem, FormControlLabel, Checkbox, Box, CircularProgress, Typography,
    InputAdornment, Table, TableBody, TableCell, TableContainer, Container, FormHelperText, FormControl, InputLabel,
    TableHead, TableRow, Paper, TablePagination, Switch, Tooltip, DialogActions, DialogContent, DialogTitle, Dialog, Tabs, Tab,
} from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import DOMPurify from 'dompurify';
import { useTranslation } from 'react-i18next';
import moment from 'moment'
import { useNavigate, useLocation } from 'react-router-dom';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import ReactQuill, { Quill } from 'react-quill';
import {Search} from 'lucide-react';
import Page from '../../../components/Page'
import PageHeader from '../../../components/PageHeader';
import DeleteAlert from '../../../components/modal/DeleteModal';
import SnackBar from '../../../components/snackbar/snackbar';
import adminServices from '../../../services/adminServices';
import CreateMcqQuestionModel from "./CreateMcqQuestionModel";
import EditQuestionModule from "./EditMcqQuestionsModule";
import QuillEditor from '../../../components/Quill/Quill'


const CLAT = () => {
    const [page, setPage] = useState(0);
    const [pagePassage, setPagePassage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [rowsPerPagePassage, setRowsPerPagePassage] = useState(10);
    const [openCreateMcq, setOpenCreateMcq] = useState(false);
    const [openEditMcq, setOpenEditMcq] = useState(false);
    const [snackbarTitle, setSnackbarTitle] = useState('');
    const [openSnackbar, setOpenSnackbar] = useState(false);
 
    const [searchedDetails, setSearchedDetails] = useState('');
    const [assessmentDetails, setAssessmentDetails] = useState([]);
    const [deleteAlert, setDeleteAlert] = useState(false);
    const [deleteModalTitle, setDeleteModalTitle] = useState('');
    const [deleteId, setDeleteId] = useState('')
    const [deleteType, setDeleteType] = useState('')
    const [totalCount, setTotalCount] = useState('')
    const [totalCountPassage, setTotalCountPassage] = useState('')

    const [openUserMessage, setOpenUserMessage] = useState(false)
    const [userMessageData, setUserMessageData] = useState('')
    const [userMessageFromDateAndTime, setUserMessageFromDateAndTime] = useState('')
    const [userMessageToDateAndTime, setUserMessageToDateAndTime] = useState('')
    const [currentToggleId, setCurrentToggleId] = useState('')
    const [currentToggleValue, setCurrentToggleValue] = useState('')
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const tabFromQuery = queryParams.get('tab');
    const [tabValue, setTabValue] = useState(location.state?.comingfrom ? location.state?.comingfrom : 0);
    const [allAssessmentData, setAllAssessmentData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [questionList, setQuestionList] = useState([]);
    const [maxCount, setMaxCount] = useState(0);
    const [searchText, setSearchText] = useState('');
    const [keyObjects, setKeyObjects] = useState([]);
    const [newData, setNewData] = React.useState('');
    const [deleteOpen, setDeleteOpen] = React.useState(false);
    const [openPassage, setOpenPassage] = useState(false);
    const [openEditPassage, setOpenEditPassage] = useState(false);
    const [passage, setPassage] = useState('');
    const [questionType, setQuestionType] = useState('CLATPASSAGE');
    
    const [selected, setSelected] = useState({});
    const [Preview, setPreview] = useState(false);
    const quillRefs = {
        passage: React.useRef(null),
    };
    const [passageError, setPassageError] = useState('');
    const [editPassage, setEditPassage] = useState('');
    const [passageDetails, setPassageDetails] = useState(null);
    const [passageId, setPassageId] = useState(null);
    const [deletePassageId, setDeletePassageId] = useState('');
    const [assessmenttype, setAssessmentType] = useState('CLATPASSAGE');
    const [isSubmitting, setIsSubmitting] = useState(false);



    const getModules = (targetRef) => ({
        toolbar: {
            container: [
                ["bold", "italic", "underline"],
                [{ list: "ordered" }, { list: "bullet" }],
                [{ script: "sub" }, { script: "super" }],
                [{ header: [1, 2, 3, false] }],
                ["image", { formula: { customClass: 'qlformula' } }],
                [{ color: [] }, { background: [] }],
                [{ align: [] }],
                ["clean"],
            ],
            handlers: {
                image: () => {
                    const input = document.createElement("input");
                    input.type = "file";
                    input.accept = "image/*";
                    input.click();

                    input.onchange = () => {
                        if (input.files?.length) {
                            handleFiles(input.files, targetRef);
                        }
                    };
                },
            },
        },
        clipboard: { matchVisual: false },
        imageResize: {
            parchment: Quill.import('parchment'),
            modules: ['Resize', 'DisplaySize', 'Toolbar']
        },
    });


    const formats = React.useMemo(() => [
        "bold", "italic", "underline",
        "list", "bullet",
        "script",
        "header",
        "image",
        "color", "background",
        "align", "style", "width", "height"
    ], []);



    React.useEffect(() => {
        const mountedRefs = Object.values(quillRefs).filter(ref => ref?.current);
        if (!mountedRefs.length) return;

        mountedRefs.forEach((ref) => {
            const editor = ref.current.root;
            if (!editor) return;

            const pasteHandler = (e) => {
                const items = e.clipboardData?.items;
                if (items) {
                    const files = [];
                    for (const item of items) {
                        if (item.type.indexOf("image") !== -1) {
                            e.preventDefault();
                            files.push(item.getAsFile());
                        }
                    }
                    if (files.length) handleFiles(files, ref);
                }
            };

            const dropHandler = (e) => {
                e.preventDefault();
                const files = e.dataTransfer?.files;
                if (files?.length) handleFiles(files, ref);
            };

            editor.addEventListener("paste", pasteHandler);
            editor.addEventListener("drop", dropHandler);
            editor.addEventListener("dragover", (e) => e.preventDefault());

            return () => {
                editor.removeEventListener("paste", pasteHandler);
                editor.removeEventListener("drop", dropHandler);
            };
        });
    }, [quillRefs.passage.current]);

    const passageModules = React.useMemo(() => getModules(quillRefs.passage), []);


    const handleFiles = async (files, targetRef) => {
        const quillInstance = targetRef?.current?.getEditor();
        if (!quillInstance) return;

        for (const file of files) {
            if (file.type.startsWith("image/")) {
                const range = quillInstance.getSelection(true);
                const tempId = `temp-${Date.now()}`;
                quillInstance.insertEmbed(range.index, "image", `/loading.gif?${tempId}`);
                quillInstance.setSelection(range.index + 1);

                const url = await handleUploadImage(file);
                if (url) {
                    const editorEl = quillInstance.root;
                    const imgEl = editorEl?.querySelector(`img[src="/loading.gif?${tempId}"]`);
                    if (imgEl) imgEl.setAttribute("src", url);
                }
            }
        }
    };



    const handleUploadImage = async (file) => {
        const formData = new FormData();
        formData.append("thumbImage", file);
        try {
            const imageUrl = await adminServices.postImag(formData);
            if (imageUrl?.ok) {
                return imageUrl.data;
            }
        } catch (error) {
            console.error("Image upload failed", error);
        }
        return null;
    };

    const handleCreatePassage = (e) => {
        e.currentTarget.blur();
        setPassage('');
        // setPassageDetails(null);
        setOpenPassage(true);
        // setQuestionType('');
        setPassageError('');
    };

    const handleEditPassage = (row, e) => {
        e.currentTarget?.blur(); 
        setQuestionType(assessmenttype); 
        setOpenEditPassage(true);
        setPassageError('');
        setPassageId(row?.id);
        setPassage(row?.passage_text);

    };




    const handleChange = (event, newValue) => {
        setTabValue(newValue);
        setSearchedDetails('');
        setDeleteOpen(false);
        setDeleteAlert(false);
    };
    const { t } = useTranslation('translation');
    const navigate = useNavigate();

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleChangePagePassage = (event, newPage) => {
        setPagePassage(newPage);
    };


    const handleChangeRowsPerPagePassage = (event) => {
        setRowsPerPagePassage(parseInt(event.target.value, 10));
        setPagePassage(0);
    };




    useEffect(() => {
        if(tabValue === 1){
            getNEETAssessmentDetails();
        }

    }, [page, rowsPerPage, searchedDetails, searchText, tabValue])


    useEffect(() => {
        if(tabValue === 0){
            getPassageDetails(assessmenttype);
        }
    }, [pagePassage, rowsPerPagePassage, searchedDetails, assessmenttype, tabValue])



    const getNEETAssessmentDetails = async () => {
        setLoading(true);
        try {
            const result = await adminServices.getAllAssessmentData(searchedDetails, page, rowsPerPage, "Clat");
            if (result.ok) {
                setAllAssessmentData(result.data.data)
                setTotalCount(result.data.pagination)
            }
        } catch (error) {
            console.log("Error getting Clat Assessments:", error);
        } finally {
            setLoading(false);
        }

    }

    const getPassageDetails = async (type) => {
        setLoading(true);
        try {
            const response = await adminServices.getPassage(pagePassage, rowsPerPagePassage, type, searchedDetails || '');

            if (response.ok) {
                setPassageDetails(response.data.data);
                setTotalCountPassage(response.data.total);
            }
        } catch (error) {
            console.log("Error getting passages:", error);
        } finally {
            setLoading(false);
        }
    };

    const handlePreviewOpen = (passage) => {
        setPreview(true)
        setPassageId(passage?.id);
    }

    const Validation = () => {
        const stripHtml = (html) => {
            const doc = new DOMParser().parseFromString(html, "text/html");
            return doc.body.textContent || "";
        };

        const textContent = stripHtml(passage).trim();

        if (!textContent || textContent.length === 0) {
            setPassageError("Passage cannot be empty");
            setIsSubmitting(false);
            return false;
        }

        return true;
    }


    const handleSubmitPassage = async () => {
        if (isSubmitting) return;

        const Valid = Validation();

        if (Valid) {
            const body = {
                name: passage,
                type: questionType
            }

            try {
                setIsSubmitting(true);
                const response = await adminServices.createPassage(body);
                if (response.ok) {
                    setSnackbarTitle('Passage created successfully');
                    setOpenPassage(false);
                    setPassage('');
                    getPassageDetails(assessmenttype);

                }
            } catch (error) {
                console.error("An error occurred:", error);

            } finally {
                setIsSubmitting(false);
            }
        }

    }

    const handleUpdatePassage = async () => {

        const Valid = Validation();

        if (Valid) {
            setIsSubmitting(true);
            const body = {
                id: passageId,
                name: passage,
                type: questionType
            };

            try {
                if (passageId) {

                    const response = await adminServices.updatePassage(body);
                    if (response.ok) {
                        setOpenEditPassage(false)
                        getPassageDetails(assessmenttype);
                    }
                    setOpenSnackbar(true);
                    setSnackbarTitle(response.ok ? 'Passage updated successfully' : 'Failed to update passage');
                }
            } catch (error) {
                console.error("An error occurred:", error);

            } finally {
                setIsSubmitting(false);
            }
        }
    }


    const handleToggleButton = (id, value, type) => {
        if (value === false) {
            setOpenUserMessage(true);
            setCurrentToggleId(id);
            setCurrentToggleValue(value);
            return;
        }
        callUpdateStatusAPI(id, value);
    };

    const callUpdateStatusAPI = async (id, value, userData) => {
        try {
            const result = await adminServices.UpdateGeneralAssessmentStatus(id, value, userData, 'Status');
            if (result.ok) {
                setSnackbarTitle(t('Assessment status updated successfully'));
                setOpenSnackbar(true);
            }
        } catch (error) {
            console.log(error, 'error');
        }
    };
    const getMaintenanceTooltip = (userMessage) => {
        if (!userMessage) {
            return "No maintenance scheduled";
        }
        const { message, fromDate, toDate } = userMessage;
        const displayMessage = message || "No message";

        return `Maintenance: ${displayMessage}\nFrom: ${fromDate}\nTo: ${toDate}`;
    };
    const handleSubmitUserMessage = () => {
        const userData = {
            message: userMessageData,
            fromDate: userMessageFromDateAndTime,
            toDate: userMessageToDateAndTime,
        };

        callUpdateStatusAPI(currentToggleId, currentToggleValue, userData);

        setOpenUserMessage(false);
        setUserMessageData('');
        setUserMessageFromDateAndTime('');
        setUserMessageToDateAndTime('');
    };


    const handleCreateCLAT = () => {
        navigate("/app/clatmain")
    }
    const handleToggleButtonMaintenance = async (id, value, type) => {

        try {
            const result = await adminServices.UpdateGeneralAssessmentMaintenance(id, value, type);
            if (result.ok) {
                setSnackbarTitle(t('CLAT Assessment status updated successfully'));
                setOpenSnackbar(true);
            }
        } catch (error) {
            console.log(error, 'error');
        }
    }

    const handleDelete = (data) => {
        setDeleteAlert(true);
        setDeleteId(data.id);
        setDeleteType(data?.question_type);
        setDeleteModalTitle('Are you sure you want delete this CLAT Assessment?');
    }

    const handleEditAssessment = (data) => {
        navigate('/app/clatmain', { state: data?.id })
    }

    const handleDeleteNEET = async () => {
        try {
            const response = await adminServices.deleteAssessment(deleteId, "Clat");
            if (response.ok) {
                setSnackbarTitle('CLAT Assessment deleted successfully');
                setOpenSnackbar(true);
                getAllQuestions();
                getNEETAssessmentDetails();
                setDeleteAlert(false)
                setDeleteId('')
                setDeleteType('')
                setDeleteModalTitle("");
            }
            else {
                setSnackbarTitle(response?.data?.error || 'Failed to delete CLAT');
                setOpenSnackbar(true);
            }
        } catch (error) {
            console.log(error);
        }
    }

    const handleDeletePassageById = async () => {
        try {
          const response = await adminServices.deletePassage(deletePassageId);
          if (response.ok) {
            setOpenSnackbar(true); 
            setDeleteOpen(false);
            setDeleteAlert(false);
            setSnackbarTitle(response?.data?.message || "Passage deleted successfully");
            setTimeout(() => {
            
              getPassageDetails(assessmenttype);
       
              setDeletePassageId('');
            }, 5000);
       
          } else {
            setSnackbarTitle("Failed to delete passage");
            setOpenSnackbar(true);
          }
        } catch (error) {
          console.error("Error deleting passage:", error);
          setSnackbarTitle("Error: Failed to delete passage");
          setOpenSnackbar(true);
        }
      };
    const getAllQuestions = async () => {
        setLoading(true);
        const result = await adminServices.getAllNEETQuestion(rowsPerPage, page, searchText);
        if (result.ok) {
            console.log(result);
            setMaxCount(result.data.total)
            const sortedQuestions = result.data.newQuestions.sort((a, b) =>
                new Date(b.created_date) - new Date(a.created_date)
            );
            setQuestionList(sortedQuestions);
            setLoading(false);
        }
        setLoading(false);
    };

    const handleCreateQuestion = async (object, values) => {
        setLoading(true);
        try {
            const keysData = new FormData();
            keysData.append('question', values.question);
            keysData.append('explanation', values.explanation);
            keysData.append('level', values.level);
            keysData.append('questionType', values.questionType);
            if (values.selectedSkills) {
                keysData.append('cognitive_skills', values.selectedSkills);
            }
            if (values.points !== null) {
                keysData.append('points', values.points);
            }
            keysData.append('courseCategory', values.courseCategory ? values.courseCategory : null);
            keysData.append('Tag', JSON.stringify(values.keyword ? values.keyword : null));
            keysData.append('questionTag', JSON.stringify(values.studyMaterials || []));
            if (values.questionType === "IQ") {
                const updatedObject = {
                    ...object,
                    keyType: values.keyType
                };
                keysData.append('keyObj', JSON.stringify(updatedObject));
            }
            else if (values.questionType === "MCQ" || values.questionType === "screenLevelMcq" || values.questionType === 'Neet') {
                const mcqdata = {
                    question: values.question,
                    mcqOptions: values.mcqOptions.map(option => option.option),
                    correctAnswer: values.mcqOptions.map(option => option.isCorrect),
                };
                keysData.append('mcqData', JSON.stringify(mcqdata));
            }
            const response = await adminServices.createQuestions(keysData);
            if (response.ok) {
                const newQuestion = {
                    question_text: values.question,
                    question_type: values.questionType,
                    is_active: true,
                    created_date: new Date().toISOString(),
                    mcqOptions: values.mcqOptions,
                };
                setQuestionList(prevList => [newQuestion, ...prevList]);
                setOpenSnackbar(true);
                setSnackbarTitle(response.data.message);
                setOpenCreateMcq(false);
                setLoading(false);
                getAllQuestions()

            } else {
                console.error("Error:", response);
                setLoading(false);
            }
            getAllQuestions();
        } catch (error) {
            console.error("An error occurred:", error);
        }
    };

    const handleSubmitForm = async (values) => {
        const array = keyObjects;
        const object = {
            windows: {
                keyCode: values.combinedWindowKeys,
                keyName: values.combinedWindowKeyName,
            },
            mac: {
                keyCode: values.combinedMacKeys,
                keyName: values.combinedMacKeyName,
            },
            positionIndex: array.length,
        };
        array.push(object);
        setKeyObjects(array);
        handleCreateQuestion(object, values)

    }
    const handleEditCallBack = (values) => {
        const array = keyObjects;
        const object = {
            windows: {
                keyCode: values.combinedWindowKeys,
                keyName: values.combinedWindowKeyName,
            },
            mac: {
                keyCode: values.combinedMacKeys,
                keyName: values.combinedMacKeyName,
            },
            positionIndex: array.length,
        };
        array.push(object);
        handleEditCallBack1(object, values);
    }
    const handleEditCallBack1 = async (object, values) => {
        setLoading(true)
        const mergedArray = values.mcqOptions?.map((option, index) => ({
            option,
            isCorrect: values.curectAnswer[index] || false,
        }));

        try {
            const requestData = {
                question: values.question,
                level: values.level,
                questionType: values.questionType,
                explanation: values.explanation,
                points: values.points !== null ? values.points : undefined,
                courseCategory: values.courseCategory || undefined,
                Tag: values.courseCategory ? JSON.stringify(values.keyword) : JSON.stringify(values.keyword),
                cognitive_skills: values.selectedSkills

            };
            if (values.selectedSkills) {
                requestData.cognitive_skills = values.selectedSkills
            }
            if (values.questionType === "IQ") {
                const updatedObject = {
                    ...object,
                    keyType: values.keyType,
                };
                requestData.keyObj = JSON.stringify(updatedObject);
            }
            else if (values.questionType === "MCQ" || values.questionType === "screenLevelMcq" || values.questionType === 'Neet') {
                requestData.mcqData = {
                    question: values.question,
                    mcqOptions: mergedArray.map(option => option.option),
                    correctAnswer: mergedArray.map(option => option.isCorrect),
                };
            }
            const questionId = newData.id;
            const response = await adminServices.updateQuestion(questionId, requestData);
            if (response.ok) {
                setOpenSnackbar(true);
                setSnackbarTitle(response.data.message);
                setOpenEditMcq(false);
                setLoading(false);
                getAllQuestions();
            } else {
                console.error("Error:", response);
                setLoading(false);
            }
        } catch (error) {
            console.error("An error occurred:", error);
        }
    };
    const handleInputChange = (event) => {
        const newSearch = event.target.value;
        setSearchedDetails(newSearch);
    };
    const handleEdit = (values) => {
        setNewData(values)
        setOpenPassage(true)
    }


    const handleDeleteNeetQuestion = async () => {
        try {
            const response = await adminServices.deleteSATDetails(deleteId, deleteType);
            setDeleteOpen(false)
            if (response.ok) {
                if (response.data.message) {
                    setSnackbarTitle(response.data.message);
                }
                else {
                    setSnackbarTitle('CLAT Question deleted successfully');
                }
                getAllQuestions();
                setDeleteOpen(false);
                setOpenSnackbar(true);
                setDeleteId('')
                setDeleteType('')
                setDeleteModalTitle("");
            }
        } catch (error) {
            console.log(error);
        }
    }

    const handleDeletOpen = (data) => {
        setDeleteOpen(true);
        setDeletePassageId(data.id)
    }
    return (
        <Page title="CLAT Assessment">
            <PageHeader pageTitle="CLAT Assessment" submodule="submodule11111111" />
            <>
                <Tabs value={tabValue} onChange={handleChange} aria-label="CLAT tabs">
                    <Tab label="Passage" />
                    <Tab label="CLAT" />
                </Tabs>
                {tabValue === 0 &&
                    <>
                        <Container maxWidth={false} sx={{ padding: '0 !important' }}>
                            <Grid container spacing={2}>
                                <Grid align="end" item xs={12}>
                                    <FormControl size="small" sx={{ minWidth: 120 }}>
                                        <InputLabel id="complexity-level-label">Passage Type</InputLabel>
                                        <Select
                                            labelId="complexity-level-label"
                                            id="addassessmenttype"
                                            value={assessmenttype || ""}
                                            onChange={(e) => {
                                                const selectedType = e.target.value;
                                                setAssessmentType(selectedType);
                                                setPagePassage(0);
                                            }}
                                            label="Passage Type"
                                            sx={{
                                                mr: 1,
                                                // height: 36,
                                                '& .MuiSelect-select': {
                                                    // fontSize: 14,
                                                    padding: "8px 12px",
                                                    width: '50px'

                                                },
                                            }}
                                        >
                                            <MenuItem value="CLATPASSAGE">CLAT</MenuItem>
                                            <MenuItem value="JEEPASSAGE">JEE</MenuItem>
                                        </Select>
                                    </FormControl>
                                    <TextField
                                        variant="outlined"
                                        placeholder="Search Passage"
                                        size="small"
                                        sx={{ width: '250px', height: '40px' }}
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <Search id="searchQuestionIconbtn" />
                                                </InputAdornment>
                                            ),
                                            sx: { height: '100%' },
                                        }}
                                        value={searchedDetails}
                                        onChange={handleInputChange}
                                    />
                                    <Button
                                        style={{ marginLeft: '15px', height: '40px' }}
                                        id="createQuestionButton"
                                        variant="contained"
                                        color="primary"
                                        onClick={handleCreatePassage}
                                    >
                                        Create Passage
                                    </Button>

                                </Grid>
                                <TableContainer component={Paper}>
                                    <Table>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>Name</TableCell>
                                                {/* <TableCell>Type</TableCell>
                                                <TableCell>Status</TableCell>
                                                <TableCell>Author</TableCell>
                                                <TableCell>Date</TableCell> */}
                                                <TableCell>Action</TableCell>
                                            </TableRow>
                                        </TableHead>

                                        <TableBody>
                                            {loading && (
                                                <TableRow>
                                                    <TableCell colSpan={5} style={{ textAlign: 'center' }}>
                                                        Loading...
                                                    </TableCell>
                                                </TableRow>
                                            )}

                                            {!loading && passageDetails?.length === 0 && (
                                                <TableRow>
                                                    <TableCell colSpan={5} style={{ textAlign: 'center' }}>
                                                        Sorry, there is no matching data to display
                                                    </TableCell>
                                                </TableRow>
                                            )}
                                            {!loading && passageDetails?.length > 0 && passageDetails.map((row, index) => (
                                                <TableRow key={index}>
                                                    {/* <TableCell dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(row.passage_text) }} /> */}
                                                    {/* <TableCell>{row.passage_text}</TableCell> */}
                                                    {/* <TableCell style={{ color: row.is_active ? 'green' : 'red' }}>
                                                        {row.is_active ? 'Active' : 'Inactive'}
                                                    </TableCell> */}
                                                    {/* <TableCell>{row?.firstname} {row?.lastname}</TableCell> */}
                                                    {/* <TableCell>{moment(row.created_date).isValid() ? moment(row.created_date).format('MM-DD-YYYY (h:mm A)') : 'Invalid Date'}
                                                    </TableCell> */}
                                                    <TableCell>
                                                        <div
                                                            dangerouslySetInnerHTML={{ __html: row.passage_text }}
                                                        />
                                                    </TableCell>
                                                    <TableCell>
                                                        <IconButton id='VisibilityIcon' style={{ height: '40px' }} color="error" onClick={() => handlePreviewOpen(row)}>
                                                            <VisibilityIcon />
                                                        </IconButton>
                                                        <IconButton id={`edit${row.id}`} color="primary" onClick={(e) => handleEditPassage(row,e)}>
                                                            <EditIcon />
                                                        </IconButton>
                                                        <IconButton id={`delete${row.id}`} color="secondary" onClick={() => handleDeletOpen(row)}>
                                                            <DeleteIcon />
                                                        </IconButton>
                                                        {/* {row?.is_linked_to_assessment === false ?
                                                            <IconButton id={`delete${row.id}`} color="secondary" onClick={() => handleDeletOpen(row)}>
                                                                <DeleteIcon />
                                                            </IconButton>
                                                            :
                                                            <>
                                                                <Tooltip title="This Passsage is a part of CLAT !" arrow>
                                                                    <span>
                                                                        <IconButton id={`delete${row.id}`} color="secondary" disabled>
                                                                            <DeleteIcon />
                                                                        </IconButton>
                                                                    </span>
                                                                </Tooltip>
                                                            </>

                                                        } */}
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>



                                <Grid item xs="12" sm="12" md="12" lg="12" xl="12">
                                    <div >
                                        <TablePagination
                                            component="div"
                                            count={totalCountPassage}
                                            page={pagePassage}
                                            onPageChange={handleChangePagePassage}
                                            rowsPerPage={rowsPerPagePassage}
                                            onRowsPerPageChange={handleChangeRowsPerPagePassage}
                                            rowsPerPageOptions={[5, 10, 15, 20, 25]}
                                            sx={{ marginTop: 2 }}
                                        />
                                    </div>
                                </Grid>
                            </Grid>
                        </Container>

                        <CreateMcqQuestionModel
                            open={openCreateMcq}
                            modelClose={() => setOpenCreateMcq(!openCreateMcq)}
                            title="Create Questions"
                            handleCreateMcq={handleSubmitForm}
                            loading={loading}
                            searchedDetails={searchedDetails}
                        />
                        <EditQuestionModule
                            open={openEditMcq}
                            modelClose={() => setOpenEditMcq(!openEditMcq)}
                            title="Edit Questions"
                            handleEditMcq={handleEditCallBack}
                            loading={loading}
                            searchedDetails={searchedDetails}
                            data={newData}
                        />
                    </>

                }


                {tabValue === 1 && <Grid container spacing={2}>
                    <Grid align="end" item xs={12}>
                        <TextField
                            variant="outlined"
                            placeholder="Search Name"
                            id="searchassessment"
                            size="small"
                            sx={{ width: '250px', height: '40px' }}
                            value={searchedDetails}
                            onChange={(e) => setSearchedDetails(e.target.value)}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <Search id="searchAssessmentIconbtn" />
                                    </InputAdornment>
                                ),
                                sx: { height: '100%' },
                            }}
                        />
                        <Button
                            style={{ marginLeft: '15px', height: '40px' }}
                            id="createassessmentButtongeneral"
                            variant="contained"
                            color="primary"
                            onClick={() => handleCreateCLAT()}
                        >
                            Add Assessment
                        </Button>
                    </Grid>
                    <TableContainer component={Paper} sx={{ marginTop: 2 }}>
                        <Table sx={{ marginLeft: '15px', width: '98%' }}>
                            <TableHead>
                                <TableRow>
                                    {/* <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f5f5f5', paddingLeft: '8px !important' }}>Name</TableCell> */}
                                    <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>Name</TableCell>

                                    {/* <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>Live</TableCell> */}
                                    {/* <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>Questions</TableCell> */}
                                    <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>Level</TableCell>
                                    <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>Status</TableCell>
                                    <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>Author</TableCell>
                                    <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>Date</TableCell>
                                    <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>Actions</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {/* {loading && (
                                    <TableRow>
                                        <TableCell colSpan={5} style={{ textAlign: 'center' }}>
                                            Loading...
                                        </TableCell>
                                    </TableRow>
                                )} */}

                                {allAssessmentData && allAssessmentData?.length > 0 && (
                                    allAssessmentData?.map((row) => (
                                        <TableRow key={row?.id} sx={{ '&:hover': { backgroundColor: '#f1f1f1' } }}>
                                            {/* <TableCell sx={{ padding: '10px' }}>{row?.assessment?.title}</TableCell> */}
                                            {/* <TableCell sx={{ marginLeft: '40px' }}>{row?.question_type}</TableCell> */}


                                            <TableCell sx={{ marginLeft: '40px' }}>{row?.title}</TableCell>
                                            <TableCell sx={{ marginLeft: '40px' }}>{row?.complexity_level}</TableCell>
                                            <div style={{ display: "flex", flexDirection: "row", gap: "8px", padding: '16px' }}>
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            checked={
                                                                selected[row.id]
                                                                    ? selected[row.id] === "ACTIVE"
                                                                    : row.status_type === 1
                                                            }
                                                        //    onChange={() => handleChangeCheckBox(row.id, "ACTIVE")}
                                                        />
                                                    }
                                                    label="Active"
                                                />
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            checked={
                                                                selected[row.id]
                                                                    ? selected[row.id] === "INACTIVE"
                                                                    : row.status_type === 2
                                                            }
                                                        //    onChange={() => handleChangeCheckBox(row.assessment.id, "INACTIVE")}
                                                        />
                                                    }
                                                    label="InActive"
                                                />
                                                <Tooltip
                                                    title={getMaintenanceTooltip(row.user_message)}
                                                    placement="top"
                                                    arrow
                                                >
                                                    <FormControlLabel
                                                        control={
                                                            <Checkbox
                                                                checked={
                                                                    selected[row.id]
                                                                        ? selected[row.id] === "ON_MAINTENANCE"
                                                                        : row.status_type === 4
                                                                }
                                                            //    onChange={() => handleChangeCheckBox(row.assessment.id, "ON_MAINTENANCE")}
                                                            />
                                                        }
                                                        label="Maintenance"
                                                    />
                                                </Tooltip>
                                            </div>

                                            <TableCell>{row?.author_first_name}</TableCell>

                                            <TableCell>
                                                {moment(row?.created_date_time).format("DD/MM/YYYY")}
                                            </TableCell>
                                            <TableCell sx={{ padding: '10px' }}>
                                                <IconButton
                                                    disabled={row?.is_published === true}
                                                    id={`editsat${row?.id}`}
                                                    onClick={() => handleEditAssessment(row)}
                                                    color="primary">
                                                    <EditIcon />
                                                </IconButton>
                                                <IconButton
                                                    disabled={row?.is_published === true}
                                                    id={`deletesat${row?.id}`}
                                                    onClick={() => handleDelete(row)}
                                                    color="primary">
                                                    <DeleteIcon />
                                                </IconButton>
                                            </TableCell>
                                        </TableRow>
                                    ))
                                )
                                    // : (
                                    //     <TableRow>
                                    //         <TableCell colSpan={8} style={{ textAlign: 'center' }}>
                                    //             {!loading && openCreateSat && openCreateSat?.length === 0 && "No Data Found"}
                                    //         </TableCell>
                                    //     </TableRow>
                                    // )
                                }
                            </TableBody>




                        </Table>
                    </TableContainer>

                    <TablePagination
                        component="div"
                        count={totalCount?.total_count}
                        page={page}
                        onPageChange={handleChangePage}
                        rowsPerPage={rowsPerPage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                        rowsPerPageOptions={[5, 10, 15, 20, 25]}
                        sx={{ marginTop: 2 }}
                    />
                    <DeleteAlert
                        open={deleteAlert}
                        title={deleteModalTitle}
                        confirm={handleDeleteNEET}
                        close={() => setDeleteAlert(false)}
                    />

                </Grid>}
                <SnackBar open={openSnackbar} snackbarTitle={snackbarTitle} close={() => setOpenSnackbar(false)} />


            </>
            <Dialog open={openUserMessage} onClose={() => setOpenUserMessage(false)}>
                <DialogTitle>Provide Message and Date Range</DialogTitle>
                <DialogContent>
                    <TextField
                        label="Message"
                        value={userMessageData}
                        onChange={(e) => setUserMessageData(e.target.value)}
                        fullWidth
                        multiline
                        rows={3}
                        margin="normal"
                    />
                    <TextField
                        label="From Date"
                        type="datetime-local"
                        value={userMessageFromDateAndTime}
                        onChange={(e) => setUserMessageFromDateAndTime(e.target.value)}
                        fullWidth
                        margin="normal"
                        InputLabelProps={{ shrink: true }}
                    />
                    <TextField
                        label="To Date"
                        type="datetime-local"
                        value={userMessageToDateAndTime}
                        onChange={(e) => setUserMessageToDateAndTime(e.target.value)}
                        fullWidth
                        margin="normal"
                        InputLabelProps={{ shrink: true }}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpenUserMessage(false)}>Cancel</Button>
                    <Button onClick={handleSubmitUserMessage} variant="contained" color="primary">
                        Submit
                    </Button>
                </DialogActions>
            </Dialog >

            <Dialog
                open={openPassage}
                onClose={() => setOpenPassage(false)}
                fullWidth
                maxWidth="sm"
            >
                <DialogTitle>Create Passage</DialogTitle>
                <DialogContent>

                    <FormControl fullWidth margin="normal">
                        <InputLabel id="question-type-label">Passage Type*</InputLabel>
                        <Select
                            labelId="question-type-label"
                            id="PassageType"
                            name="PassageType"
                            label="Passage Type"
                            value={questionType}
                            onChange={(e) => setQuestionType(e.target.value)}
                        >
                            <MenuItem value="CLATPASSAGE">Clat</MenuItem>
                            <MenuItem value="JEEPASSAGE">JEE</MenuItem>
                        </Select>
                    </FormControl>

                    <QuillEditor
                        ref={quillRefs.passage}
                        value={passage}
                        onChange={(content, delta, source, editor) => {
                            setPassage(content);
                            setPassageError('');
                        }}
                        theme="snow"
                        id='questionTxt'
                        name="question"
                        modules={passageModules}
                        formats={formats}

                        preserveWhitespace
                        fullWidth
                    />

                    {/* <TextField
                        label="Passage"
                        value={passage}
                        onChange={(e) => {
                            setPassage(e.target.value);
                            setPassageError('');
                        }}
                        fullWidth
                        multiline
                        rows={6}
                        margin="normal"
                    /> */}
                    {passageError && (
                        <FormHelperText error>{passageError}</FormHelperText>
                    )}

                </DialogContent>

                <DialogActions sx={{ p: 2, justifyContent: 'flex-end' }}>
                    <Button
                        onClick={() => {
                            setOpenPassage(false);
                            // setPassage('');
                        }}

                        color="inherit"
                    >
                        Cancel
                    </Button>
                    <Button
                        onClick={handleSubmitPassage}
                        variant="contained"
                        color="primary"
                        disabled={isSubmitting}
                    >
                        {isSubmitting ? 'Submitting...' : 'Submit'}

                    </Button>
                </DialogActions>
            </Dialog>


            {/* <Dialog open={openPassage} onClose={() => setOpenPassage(false)}> */}
            <Dialog open={openEditPassage} onClose={() => setOpenEditPassage(false)}>

                <DialogTitle>Edit Passage</DialogTitle>
                <DialogContent>
                    <FormControl fullWidth margin="normal">
                        <InputLabel id="question-type-label">Passage Type*</InputLabel>
                        <Select
                            labelId="question-type-label"
                            id="PassageType"
                            name="PassageType"
                            label="Passage Type"
                            value={questionType}
                            onChange={(e) => setQuestionType(e.target.value)}
                        >
                            <MenuItem value="CLATPASSAGE">Clat</MenuItem>
                            <MenuItem value="JEEPASSAGE">JEE</MenuItem>
                        </Select>
                    </FormControl>
                    <QuillEditor
                        ref={quillRefs.passage}
                        value={passage}
                        onChange={(content, delta, source, editor) => {
                            setPassage(content);
                            setPassageError('');
                        }}
                        theme="snow"
                        id='questionTxt'
                        name="question"
                        modules={passageModules}
                        formats={formats}

                        preserveWhitespace
                        fullWidth
                    />

                    {/* <TextField
                        label="Passage"
                        value={passage}
                        onChange={(e) => {
                            setPassage(e.target.value);
                            setPassageError('');
                        }}
                        fullWidth
                        multiline
                        rows={6}
                        margin="normal"
                        sx={{ minWidth: 500 }}
                    /> */}
                    {passageError && (
                        <FormHelperText error>{passageError}</FormHelperText>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={() => {
                            setOpenEditPassage(false);
                            // setPassage('');
                            // setPassageDetails(null);
                        }}
                    >
                        Cancel
                    </Button>
                    <Button
                        onClick={handleUpdatePassage}
                        variant="contained"
                        disabled={isSubmitting}
                    >
                        {isSubmitting ? 'Updating...' : 'Update'}
                    </Button>
                </DialogActions>
            </Dialog>

            <DeleteAlert
                open={deleteOpen}
                title="Are you sure you want delete this Passage !"
                confirm={handleDeletePassageById}
                close={() => setDeleteOpen(false)}
            />
            <Dialog open={Preview} onClose={() => setPreview(false)} maxWidth="md" fullWidth>
                <DialogTitle>Preview</DialogTitle>
                <DialogContent>
                    {passageDetails && passageId ? (passageDetails.filter((passage) => passage.id === passageId).map((passage, passageIndex) => (
                        <div key={passage.id}>
                            <Typography variant="h6" style={{ marginTop: '10px', marginBottom: '10px', fontWeight: '600' }} >
                                Passage
                            </Typography>
                            <Typography dangerouslySetInnerHTML={{ __html: passage.passage_text }} variant="body2" style={{ marginBottom: '15px', color: '#666' }}/>

                            <ol style={{ marginLeft: '30px' }} type="1">
                                {passage.questions && passage.questions.length > 0 ? (
                                    passage.questions.map((q, questionIndex) => (
                                        <li key={questionIndex}>
                                            <Box style={{ display: 'flex', alignItems: 'center', marginBottom: '10px', justifyContent: 'space-between', }} >
                                                    <Box style={{ display: 'flex', alignItems: 'flex-start', gap: '8px', flex: 1 }}>
                                                                                        <Typography
                                                                                          style={{
                                                                                            lineHeight: '1.2',
                                                                                            fontSize: '15px',
                                                                                            fontWeight: '500',
                                                                                            minWidth: '22px',
                                                                                          }}
                                                                                        >
                                                                                          {questionIndex + 1}.
                                                                                        </Typography>
                                                <Typography style={{ lineHeight: '1.2', fontSize: '15px', fontWeight: '400', paddingRight: '15px', }}
                                                    dangerouslySetInnerHTML={{ __html: q?.question_text }} />
                                            </Box>
                                            </Box>
                                        </li>
                                    ))
                                ) : (
                                    <Typography variant="body2" style={{ fontStyle: 'italic', color: '#999' }} >
                                        No questions for this passage
                                    </Typography>
                                )}
                            </ol>
                        </div>
                    ))
                    ) : (
                        <div style={{ textAlign: 'center', marginTop: '20px' }}>
                            <Typography>No passage selected</Typography>
                        </div>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setPreview(false)}>Close</Button>
                </DialogActions>
            </Dialog>


        </Page>
    )
}

export default CLAT;